// extracted by mini-css-extract-plugin
export default {"button":"whG4H","level-primary":"GkgAG","level-secondary":"qsInr","level-destructive":"UHb_x","is-processing":"nH3wy","spinner":"gk4gH"};